var _clipPath, _filter, _rect, _g, _mask, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 502 271",
    width: 502,
    height: 271,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_4094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 271,
    x: 0,
    y: 0
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4099",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4098",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4099)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 271,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.559999942779541,0,0,4.559999942779541,461.2569885253906,78.95500183105469)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.25,4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "animatedPath",
    pathLength: 1,
    fill: "rgb(255,60,0)",
    fillOpacity: 1,
    d: " M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
  })))))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "__element_4103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "animatedPath",
    pathLength: 1,
    fill: "#ffffff",
    clipRule: "nonzero",
    d: "M0,0  h502 v271 h-502 v-271  M474.8580017089844,122.14399719238281 C474.8580017089844,122.14399719238281 458.6080017089844,141.3939971923828 458.6080017089844,141.3939971923828 C458.6080017089844,141.3939971923828 472.6080017089844,149.3939971923828 472.6080017089844,149.3939971923828 C472.6080017089844,149.3939971923828 485.3580017089844,134.1439971923828 483.8580017089844,133.1439971923828 C482.3580017089844,132.1439971923828 474.8580017089844,122.14399719238281 474.8580017089844,122.14399719238281",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_4094)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,476.3869934082031,94.08499908447266)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.25,4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "animatedPath",
    pathLength: 1,
    fill: "rgb(255,60,0)",
    fillOpacity: 1,
    d: " M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4098)",
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4103)",
    transform: "matrix(1,0,0,1,9.642013549804688,-38.14500427246094)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,237.5679931640625,171.531005859375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "animatedPath",
    pathLength: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    fillOpacity: 0,
    stroke: "rgb(255,60,0)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-233.5679931640625,-22.527000427246094 C-55.83599853515625,167.531005859375 197.0260009765625,-38.18600082397461 177.17300415039062,-94.98200225830078 C151.81399536132812,-167.52999877929688 -42.571998596191406,70.6449966430664 79.93199920654297,85.28500366210938 C115.3949966430664,89.52300262451172 172.5,69.41300201416016 228.60499572753906,-26.047000885009766"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiral);
export default __webpack_public_path__ + "static/media/spiral.262ef9a12a9fbbb3503d2be7a64780eb.svg";
export { ForwardRef as ReactComponent };